import { Component, Inject, Input, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { Requisition } from '../models/requisition';
import { JobsOffer } from '../models/jobs-offer';
import { ConfigurationService } from '../services/configuration.service';
import { Apply } from './../models/apply';
import { JobOffersService } from '../services/job-offers.service';
import { ReportService } from '../services/report.service';

@Component({
  selector: 'app-view-dossier-dialog',
  templateUrl: './view-dossier-dialog.component.html',
  styleUrls: ['./view-dossier-dialog.component.css']
})
export class ViewDossierDialogComponent implements OnInit {
  job: JobsOffer;
  create: boolean;
  role: string;
  email: string;
  applicants: Apply;
  @Input() nameComponent;
  errorMessage: string;
  reportDescription: string = null;
  loading: boolean;
  public step: number;
  emailRegex: any = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

  constructor(public dialog: MatDialog,
              public dialogRef: MatDialogRef<ViewDossierDialogComponent>,
              private jobService: JobOffersService,
              private reportService: ReportService,
              private configurationService: ConfigurationService,
              @Inject(MAT_DIALOG_DATA) public data: any,
              ) {
  }

  ngOnInit () {
    this.loading = false;
    this.job = this.data.job;
    this.create = this.data.create;

    this.configurationService.configuration$.subscribe(
      response => {
        if (response) {
          this.role = localStorage.getItem('role');
        }
      }
    );
    this.jobService.getOffersApplicantByOfferDossier(this.job.id).subscribe(
      data => {
        const applicantss: any = data.applicants;
        const list = [];
        if (this.create) {
          applicantss.forEach(element => {
            element.firstname = element.user.firstname;
            element.lastname = element.user.lastname;
            element.photo = element.user.photo;
            element.user_id = element.user.id;
            element.email = element.user.email;
            element.description = '';
            list.push(element);
          });
        } else {
          this.reportDescription = this.job.report.moreinfo;
          console.log(applicantss);
          applicantss.forEach(element => {
            let desc = '';
            this.job.report.selected.forEach(element2 => {
              if (element.user.id === element2.user_id) {
                desc = element2.moreinfo;
              }
            });
            element.firstname = element.user.firstname;
            element.lastname = element.user.lastname;
            element.photo = element.user.photo;
            element.user_id = element.user.id;
            element.email = element.user.email;
            element.description = desc;
            list.push(element);
          });
        }

        this.applicants = list;
        this.loading = false;
      },
      error => {
        this.errorMessage = <any>error;
        this.loading = false;
      }
    );
  }

  downloadPDF(){
    this.reportService.getDossierPDF(this.job.id).subscribe(
      data => {
        const fileURL = URL.createObjectURL(data);
        const link = document.createElement('a');
        link.download = new Date() + '.pdf';
        link.target = '_blank';
        link.href = fileURL;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      },
      error => {
        this.errorMessage = <any>error;
      }
    );
  }


  validEmail () {
    if (this.email !== undefined && this.email !== '') {
      const a = this.emailRegex.test(this.email);
      return a;
    }
    return true;
  }



  onReport() {
    if (this.create) {
      this.onPostReport();
    } else {
      this.onPutReport();
    }
  }

  onPostReport() {
    this.reportService.postReport(this.job.id, this.reportDescription, this.applicants, this.email).subscribe(
      data => {
        this.jobService.getOffersById(this.job.id).subscribe(
          data2 => {
            this.job = data2;
            this.jobService.publish(this.job);
          },
          error => {
            this.errorMessage = <any>error;
          }
        );
        this.dialogRef.close('yes');
      },
      error => {
        this.errorMessage = <any>error;
        this.loading = false;
      }
    );
  }

  onPutReport() {
    console.log('hola1');
    this.reportService.putReport(this.job.id, this.reportDescription, this.applicants, this.email).subscribe(
      data => {
        console.log('hola2');
        this.dialogRef.close('yes');
      },
      error => {
        this.errorMessage = <any>error;
        this.loading = false;
      }
    );
  }
}



// WEBPACK FOOTER //
// /Users/everis/code/Dj/front.staff/src/app/view-dossier-dialog/view-dossier-dialog.component.ts